<svelte:window on:keyup={onWindowKeyUp} />

<div
    bind:this={tooltip}
    id="{id}-{role}"
    class="prom-tooltip prom-tooltip-{id} prom-tooltip--{placement} {displayClass}"
    role="{role}"
    on:mouseenter={hoverTooltip}
    on:mouseleave={unhoverTooltip}
>
    <div bind:this={arrow} id="tooltip-arrow" class="prom-tooltip__arrow"></div>
    <div bind:this={tooltipContent} id="tooltip-content" class="prom-tooltip__content">
        {#if text}
            {text}
        {:else}
            <slot></slot>
        {/if}
    </div>
</div>

<script>
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import { onDestroy, onMount } from 'svelte';

    /** @type {Element} */
    export let element = null;
    /** @type {string} */
    export let id = 'mytooltip';
    /** @type {'top'|'left'|'right'|'bottom'} */
    export let placement = 'top';
    /** @type {string} */
    export let role = 'tooltip';
    /** @type {boolean} */
    export let show = false;
    /** @type {string} */
    export let text = '';
    export let hover = false;

    let tooltip;
    let arrow;
    let tooltipContent;

    $: displayClass = show ? '' : 'prom-tooltip__hidden';

    $: if (show) {
        updateTooltip(show);
    }

    onMount(() => {
        setElementAttribute(show);
    });

    onDestroy(() => {
        setElementAttribute(false);
    });

    function onWindowKeyUp(event) {
        const key = normalizeKey(event.key);

        if (key === Keys.ESCAPE) {
            show = false;
        }
    }

    function hoverTooltip() {
        hover = true;
        show = true;
    }

    function unhoverTooltip() {
        hover = false;
        show = false;
    }

    function updateTooltip(show) {
        setElementAttribute(show);

        if (show) {
            setTimeout(setPosition, 0);
        }
    }

    function setElementAttribute(isTooltipShown) {
        if (isTooltipShown) {
            if (element && role === 'tooltip') {
                const describedBy = id + '-' + role;

                element.setAttribute('aria-describedby', describedBy);
            }
        } else {
            if (element && element.hasAttribute('aria-describedby')) {
                element.removeAttribute('aria-describedby');
            }
        }
    }

    function setPosition() {

        if (!element) {
            return;
        }

        const rect = element.getBoundingClientRect();
        const tooltipHeight = tooltip.offsetHeight;
        const tooltipWidth = tooltip.offsetWidth;
        const horizontalPlacementOffset = 15;
        const verticalPlacementOffset = 15;

        let left, top;

        switch (placement) {
            case 'top':
                left = rect.left - tooltipWidth / 2 + rect.width / 2;
                top = rect.top - tooltipHeight - horizontalPlacementOffset + window.pageYOffset;
                break;
            case 'bottom':
                left = rect.left - tooltipWidth / 2 + rect.width / 2;
                top = rect.bottom + horizontalPlacementOffset + window.pageYOffset;
                break;
            case 'left':
                left = rect.left - tooltipWidth - verticalPlacementOffset;
                top = rect.top + (rect.height - tooltipHeight) / 2 + window.pageYOffset;
                break;
            case 'right':
                left = rect.right + verticalPlacementOffset;
                top = rect.top + (rect.height - tooltipHeight) / 2 + window.pageYOffset;
                break;
            default:
                break;
        }

        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
    }
</script>
